import { useCallback, useState } from 'react';
import { experimentService } from 'src/services';

interface UseProvisioningRetryArguments {
  shopId: number;
  experimentId: string | undefined;
  onRetried?: () => void;
}

interface UseProvisioningRetryReturnType {
  isRetrying: boolean;
  retryError: string | undefined;
  onRetryProvisioning: () => void;
}

export const useProvisioningRetry = ({
  shopId,
  experimentId,
  onRetried,
}: UseProvisioningRetryArguments): UseProvisioningRetryReturnType => {
  const [isRetrying, setIsRetrying] = useState(false);
  const [retryError, setRetryError] = useState<string | undefined>(undefined);

  const onRetryProvisioning = useCallback((): void => {
    if (!experimentId) return;

    setIsRetrying(true);
    setRetryError(undefined);

    experimentService
      .retryProvisioning({ shopId, id: experimentId })
      .catch(error => {
        setRetryError(
          error instanceof Error ? error.message : 'Failed to retry, please try again.'
        );
      })
      .finally(() => {
        setIsRetrying(false);
        onRetried?.();
      });
  }, [shopId, experimentId, onRetried]);

  return { isRetrying, retryError, onRetryProvisioning };
};
